// Shell navigation labels (module bar, left menu, sub-tabs, crumbs, title, About blurb) live in config/moduleTree.js in English.
// This hook returns the French (nav namespace) label when one exists and the moduleTree text otherwise, so a section is translated
// by adding keys to i18n/locales/{en,fr}/nav.json: m_<module> · s_<module>_<section> · t_<module>_<section>_<tab> · b_<module>_<section>.
import { useTranslation } from 'react-i18next';

export default function useNavLabels() {
  const { t, i18n } = useTranslation('nav');
  const pick = (key, fallback) => (i18n.exists(key, { ns: 'nav' }) ? t(key) : fallback);
  return {
    mod: m => pick(`m_${m.key}`, m.label),
    sec: (m, s) => pick(`s_${m.key}_${s.key}`, s.label),
    tab: (m, s, x) => pick(`t_${m.key}_${s.key}_${x.key}`, x.label),
    chipText: k => t(`chip_${k}`), chipTip: k => t(`chip_${k}_tip`),
    aria: (key, n) => t(`a_${key}`, { count: n }),   // badge aria-label / tooltip, e.g. a_dispatches
    blurb: (m, s) => pick(`b_${m.key}_${s.key}`, s.blurb),
  };
}
